export default "<p>dashborad works!</p>\n";